import { PatientAllowedMessageReceiverModel } from "./patientAllowedMessageReceiverModel";

export interface NewMessageModel {
  patientID?: number;
  message?: string;
  receivers?: Array<PatientAllowedMessageReceiverModel>;
}
